import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { SOFAR_TERMS_AND_CONDITIONS_URL } from 'app/shared/utils/siteUrls';
import { Typography } from 'app/shared/components/atoms';
import { NavigationLink as Link } from 'app/shared/components/atoms';

export const TermsAndConditionsSummaryRow = () => {
  const intl = useIntl();
  const { colors } = useCurrentTheme();

  return (
    <Typography
      fontSize="fontSize75"
      mt={4}
      color={colors.primary.black.base}
      textAlign="center"
    >
      {intl.formatMessage({
        id: 'event.checkout.termsAndConditionsAgree',
      })}
      <Link
        href={SOFAR_TERMS_AND_CONDITIONS_URL}
        openInNewTab={true}
        color={colors.primary.black.base}
        fontSize="fontSize75"
        textDecoration="underline"
      >
        {intl.formatMessage({
          id: 'event.checkout.termsAndConditionsLink',
        })}
      </Link>
      {intl.formatMessage({
        id: 'event.checkout.termsAndConditionsConsent',
      })}
    </Typography>
  );
};
